import { useCallback } from "react";

import { calculateArea } from "helpers/calculateArea";
import usePolygonHandler from "scenes/MapPage/usePolygonHandler";
import { useMapContext } from "context/MapContextProvider";
import { UnitInterface } from "scenes/UnitsManager/interfaces";

import EditLinePencilIcon from "assets/icons/edit-line-pencil.svg";
import { ReactComponent as AreaIcon } from "assets/icons/square-area-black.svg";
import DeleteIcon from "assets/icons/trash.svg";

import styles from "./map-polygon-context-menu.module.scss";

interface MapPolygonContextMenuInterface {
  areaData: UnitInterface;
}

const MapPolygonContextMenu = ({
  areaData
}: MapPolygonContextMenuInterface) => {
  const { closeContextMenu } = useMapContext();

  const { openPolygonDrawMode, onPolygonDelete } = usePolygonHandler(areaData);
  const areaDataCalculated = calculateArea(areaData?.geo_data?.coordinates);

  const onEditButtonClick = useCallback(() => {
    openPolygonDrawMode(areaData);
    closeContextMenu();
    console.log("edit polygon clicked");
  }, [areaData, openPolygonDrawMode, closeContextMenu]);

  const onDeleteButtonClick = useCallback(() => {
    closeContextMenu();
    console.log("delete polygon clicked");

    onPolygonDelete();
  }, [onPolygonDelete, closeContextMenu]);

  return (
    <div className={styles["context-menu-container"]}>
      <h4 className={styles["context-menu-area-name"]}>{areaData.name}</h4>
      <div className={styles["area__count-container"]}>
        <AreaIcon />
        <span className={styles["area-count"]}>
          {areaDataCalculated.areaInHectares > 1
            ? `${areaDataCalculated.areaInHectares.toFixed(5)} га`
            : `${areaDataCalculated.areaInSquareMeters.toFixed(2)} м²`}
        </span>
      </div>
      <div className={styles["divider"]} />
      <div className={styles["option"]} onClick={onEditButtonClick}>
        <div className={styles["option-icon"]}>
          <img src={EditLinePencilIcon} alt="edit" />
        </div>
        Edit
      </div>
      <div className={styles["option"]} onClick={onDeleteButtonClick}>
        <div className={styles["option-icon"]}>
          <img src={DeleteIcon} alt="delete" />
        </div>
        Delete
      </div>
      <div className={styles["divider"]} />
    </div>
  );
};

export default MapPolygonContextMenu;
